import { I1091Form } from 'legacy/lut/features/partner360/basicInfo'

import { jbpBasicInfoDataSource } from './configs'
import { getJBPBasicInfoCrud } from './helpers/getJBPBasicInfoCrud'
import { map1091ToBasicInfo } from './mappings/map1091ToBasicInfo'

interface ICreatePartnerBasicInfo extends Omit<I1091Form, 'EntryId'> {}

export const createPartnerBasicInfo = async (data: ICreatePartnerBasicInfo) => {
  const crud = getJBPBasicInfoCrud()

  const [createdItem] = await crud.create(jbpBasicInfoDataSource, [data])
  crud.removeQueries()

  return map1091ToBasicInfo(createdItem)
}
